import React from 'react';

import ItemSlider from '../../../shared/ItemSlider/ItemSlider';
import ImageThumbnail from '../../../shared/ImageThumbnail/ImageThumbnail';
import { ga4SelectPromotion } from '../../../shared/lib/ga4EnhancedEcommerce';
import { fkmxSelectPromotion } from '../../../shared/lib/farmakomMetrics';

import './TagDiscounts.scss';

const TagDiscounts = ({
  isMobile,
  loading = false,
  tags,
  discountsTitle,
  primaryColor,
  uiVariantBannerPromo,
  hasGoogleAnalytics4Advanced,
  hasFarmakomMetrics,
}) => {
  const onClick = tag => {
    if (hasGoogleAnalytics4Advanced) {
      // GA4 SELECT PROMOTION
      ga4SelectPromotion(tag);
    }
    if (hasFarmakomMetrics) {
      // FKMX SELECT PROMOTION
      fkmxSelectPromotion(tag);
    }
  };

  const renderTagDiscounts = () =>
    isMobile ? renderTagDiscountsMobile() : renderTagDiscountsDesktop();

  const renderTagDiscountsDesktop = () => {
    return (
      <div className="hidden-mobile container">
        <div className="tag-discounts">
          <ItemSlider
            fullWidth
            loading={loading}
            title={discountsTitle}
            primaryColor={primaryColor}
            uiVariant={uiVariantBannerPromo}
          >
            {tags &&
              tags.map(tag => {
                return (
                  <ImageThumbnail
                    key={tag.id}
                    image={tag.imageUrl}
                    name={tag.name}
                    url={`/tag/${tag.seoName}`}
                    uiVariant={uiVariantBannerPromo}
                    onClick={() => onClick(tag)}
                  />
                );
              })}
          </ItemSlider>
        </div>
      </div>
    );
  };

  const renderTagDiscountsMobile = () => {
    return (
      <div className="hidden-desktop tag-discounts">
        <div className="mobile-tags-container">
          {!!tags &&
            tags.map((tag, i) => {
              return (
                <div className="mobile-image-container">
                  <ImageThumbnail
                    key={tag.id}
                    image={tag.imageUrl}
                    url={`/tag/${tag.seoName}`}
                    uiVariant={uiVariantBannerPromo}
                    onClick={() => onClick(tag)}
                    lazy={i > 0}
                  />
                </div>
              );
            })}
        </div>
      </div>
    );
  };

  return <div className="tags-discount-dispatcher">{renderTagDiscounts()}</div>;
};

export default TagDiscounts;
